import React from 'react';
const comparisonRows = [{
  situation: 'Tu cobro',
  without: 'Por clase, irregular',
  with: 'Abono mensual el día 25-30'
}, {
  situation: 'Cancelaciones',
  without: 'Sin política clara',
  with: 'Reglamento firmado'
}, {
  situation: 'Ingresos',
  without: 'Impredecibles',
  with: 'Fijos y predecibles'
}, {
  situation: 'Nuevos alumnos',
  without: 'Solo boca a boca',
  with: 'Sistema de referidos activo'
}, {
  situation: 'Cuando llueve',
  without: 'Cancelás y no cobrás',
  with: 'Plan B activo — cobrás igual'
}, {
  situation: 'Tu Instagram',
  without: 'Sin estrategia',
  with: '30 días de contenido listo'
}, {
  situation: 'El alumno que falta',
  without: 'Sin sistema',
  with: 'Protocolo de re-enganche'
}, {
  situation: 'Tu precio',
  without: 'El del mercado o menos',
  with: '30-50% más justificado'
}];
const blocks = [{
  icon: '💰',
  title: 'Módulo 1 — Sistema Financiero Blindado',
  desc: 'Del cobro por clase al abono mensual adelantado. Planilla de gestión + protocolo de cobranzas.'
}, {
  icon: '🎾',
  title: 'Módulo 2 — Sistema de Cobranzas',
  desc: 'Pago adelantado + mensajes modelo para cada situación. Nunca más perseguís a nadie por WhatsApp.'
}, {
  icon: '📊',
  title: 'Módulo 3 — Base de Datos 360°',
  desc: 'Ficha digital completa de cada alumno + sistema de onboarding de 30 días para retener desde el inicio.'
}, {
  icon: '📱',
  title: 'Módulo 4 — Marketing de Guerrilla',
  desc: 'La Clase de Diagnóstico de Alto Valor + estrategia 3-3-1 de redes + sistema de referidos activo.'
}, {
  icon: '📈',
  title: 'Módulo 5 — Retención y Escala',
  desc: 'De clases sueltas a membresía mensual. Cómo delegar sin perder calidad. Convenios con clubes.'
}, {
  icon: '⚖️',
  title: 'Módulo 6 — Legal y Formal',
  desc: 'Reglamento interno + Deslinde de Responsabilidad + Contrato Ético. Protección ante cualquier imprevisto.'
}, {
  icon: '📅',
  title: 'Módulo 7 — Plan de 90 Días',
  desc: 'Implementación paso a paso. Todo instalado en 3 meses. Auditoría incluida.'
}];
const assets = ['Planilla Financiera Mensual', 'Calculadora de Precio Justo', 'Dashboard Semanal', 'Reglamento de Cancelaciones', 'Deslinde de Responsabilidad', 'Templates de WhatsApp listos', 'Scripts de Instagram', 'Plan de Marketing de 30 Días'];
export function EliteSection() {
  return <section className="w-full bg-[#001a2d] py-16 px-4" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <div className="text-center mb-10" data-id="element-70">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-71">
            🎾 ¿QUÉ AGREGA LA{' '}
            <span className="text-[#00B4D8]" data-id="element-72">ACADEMIA PRO™</span>?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-73">
            El sistema de cobro, captación e identidad que hace que tu negocio
            esté a la altura de tus clases.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#00B4D8]/30 rounded-2xl overflow-hidden mb-12" data-id="element-74">
          {/* Header */}
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#000d1a] border-b border-[#00B4D8]/30" data-id="element-75">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-76">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#00B4D8]/30" data-id="element-77">
              Sin Academia Pro
            </div>
            <div className="p-4 font-bold text-[#00B4D8] text-center border-l border-[#00B4D8]/30" data-id="element-78">
              Con Academia Pro
            </div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-1 sm:grid-cols-3${i < comparisonRows.length - 1 ? ' border-b border-gray-800' : ''}`} data-id="element-79">
              <div className="p-4 text-white text-sm sm:text-base" data-id="element-80">
                <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-81">
                  Situación:
                </span>
                {row.situation}
              </div>
              <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-82">
                <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-83">
                  Sin Academia Pro:
                </span>
                {row.without}
              </div>
              <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-84">
                <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-85">
                  Con Academia Pro:
                </span>
                {row.with}
              </div>
            </div>)}
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-86">
          ✅ ACADEMIA PRO™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-87">
          {blocks.map(block => <div key={block.title} className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-88">
              <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-89">
                {block.icon} {block.title}
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-90">{block.desc}</p>
            </div>)}

          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5 md:col-span-2" data-id="element-91">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-92">
              📊 Assets incluidos:
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-93">{assets.join(' · ')}</p>
          </div>
        </div>
      </div>
    </section>;
}